
import SupportService from "./support.service";
import SupportTicketController from "./ticket/support-ticket.controller";

export default angular
    .module('app.support', ['ngSanitize', 'ui.router'])
    .service('SupportService', SupportService)
    .controller('SupportTicketController', SupportTicketController);
